/**
 * @file 浏览器 UserAgent
 * @author svon.me@gmail.com
 */
import URL from "url";
import Bowser from "bowser";
import * as _ from "lodash-es";
import {normalize} from "./resource";
import {DBList} from "@fengqiaogang/dblist";

export * as PREVIEW from "./image";

export const minVersion = {
  "Chrome": 71,
  "Firefox": 65,
  "Safari": 12,
  "Edg": 97,
  "IE": 999
}

export const userAgent = function () {
  const device = window.navigator.userAgent;
  return Bowser.getParser(device)
}

export const satisfies = function () {
  let status = true;
  const ua = userAgent();
  const db = new DBList([], "name");
  for (const key of _.keys(minVersion)) {
    const version = Number(minVersion[key]);
    const name = _.toLower(key);
    db.insert({name: _.upperFirst(name), version});
  }
  const [browser] = db.like({name: ua.getBrowserName()}, 1) || [];
  if (browser) {
    const version = Number(ua.getBrowserVersion());
    // 如果当前浏览器小于预设版本
    if (version < browser.version) {
      status = false;
    }
  }
  return status;
}
// 使用 a 标签模拟点击下载附件
export const linkDownload = function (url, name) {
  const a = document.createElement("a");
  // initEvent 已不推荐使用
  // 后期如遇到问题请参考 https://developer.mozilla.org/zh-CN/docs/Web/API/Event/Event
  const event = document.createEvent("MouseEvents");
  event.initEvent("click", false, false);
  a.href = url;
  if (name) {
    a.target = "_blank";
    a.download = name;
  }
  a.dispatchEvent(event);
  return true;
}

// 使用 iframe 标签模拟点击下载附件
export const iframeDownload = function (url) {
  const body = document.querySelector("body");
  if (body && url) {
    // 使用 iframe 方式下载文件
    const res = document.createElement("iframe");
    res.src = url;
    res.style.display = "none";
    body.appendChild(res);
    return true;
  }
  return false;
}

// 触发浏览器下载
export const downloadFile = function (link, name) {
  // let status;
  let value = link ? normalize(link) : link;
  // if (value) {
  //   status = iframeDownload(value);
  // }
  // if (!status) {
  //   status = linkDownload(value, name)
  // }
  // return status;
  if (name) {
    return linkDownload(value, name);
  } else {
    const data = URL.parse(value);
    const params = new URLSearchParams(data.search);
    return linkDownload(value, params.get('filename'));
  }
}